const jsonToMap = jsonStr => new Map(Object.entries(JSON.parse(jsonStr)));
const mapToJson = map => JSON.stringify(Object.fromEntries(map));

export { jsonToMap, mapToJson };
